import BaseService from '../../BaseService.js';

export default class RecallService extends BaseService {

    constructor() {
        super('recalls')
    }

}